import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { balance } from 'data/actions';
import Price from 'components/Formaters/Price';


class BalanceInfo extends Component {


  componentDidMount () {
    this.props.actions.fetchBalance(this.props.accountid);
  }
  
  render () {
    var cln = this.props.amount < 0 ? 'balance_info__negative balance_info':'balance_info'
    return (
      <span className={cln}>
        <span>Saldo:</span> 
        <span ><Price value={this.props.amount}/></span>
      </span>
    )
  }
}

function mapStateToProps(state, ownProps) {
  var amount = 0;
  if (state.balance.details && state.balance.details.amount)
  {
    amount = state.balance.details.amount;
  }
  return {
    amount: amount
  };
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...balance }, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(BalanceInfo)

  



// WEBPACK FOOTER //
// ./src/components/Balance/BalanceInfo.jsx